module.exports = __webpack_public_path__ + "img/threshold.81eae561.svg";